import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { AllegatiArticoli } from 'src/app/models/allegati-articoli';


@Injectable({
  providedIn: 'root'
})
export class AllegatiArticoliService {
  private http = inject(HttpClient);

  allegatiUrl = environment.ildatoArticoliDpi + 'api/allegati/articoli';

  list(): Observable<AllegatiArticoli[]> {
    return this.http.get<AllegatiArticoli[]>(this.allegatiUrl);
  }

  listByArticolo(idArticolo: number): Observable<AllegatiArticoli[]> {
    return this.http.get<AllegatiArticoli[]>(this.allegatiUrl + '/byarticolo/' + idArticolo);
  }

  delete(idAllegato: number): Observable<AllegatiArticoli> {
    return this.http.delete<AllegatiArticoli>(this.allegatiUrl + '/'+ idAllegato);
  }

  allega(idArticolo: number, nome: string ,data: FormData): Observable<number> {
    return this.http.post<number>(this.allegatiUrl + '/newallegato/' + idArticolo + '/' + nome, data);
  }

  scarica(id: number): Observable<Blob> {
    return this.http.get(this.allegatiUrl + '/getallegato/' + id, { responseType: 'blob'});
  }

  getImmagine(id: number): Observable<string> {
    return this.http.get(this.allegatiUrl + '/getimmagine/' + id, { responseType: 'text' });
  }


}
